import CheckoutSuccessPage from './CheckoutSuccessPage'

export default CheckoutSuccessPage
